export const FILE_INCORRECT = "インポートデータが不正なため、取り込みできませんでした。";
